// Components==============
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalRootSkillContext } from 'utilities/GlobalContext/GlobalRootSkill';
import { sortOnName } from 'utilities/sortOnName';
import '../StudentOverview.module.scss';
// =========================

export default function Skills() {
  const skills = useRedux((state) =>
    state.skill?.entities.allIds.map((id) => state.skill?.entities.byId[id])
  );

  const { setRootSkillModal } = useContext(GlobalRootSkillContext);

  return (
    <>
      <motion.div {...framerFade} styleName="wrapper">
        {sortOnName(skills)?.map(
          (skill) =>
            !!skill && (
              <ReflectionIcon
                name={skill.name}
                image={`/storage/${skill.icon}`}
                onClick={() => setRootSkillModal(skill)}
                type="skill"
              />
            )
        )}
      </motion.div>
      <RootReflectionModal type="skill" />
    </>
  );
}
